var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',{attrs:{"value":_vm.value,"label":_vm.label,"items":_vm.items,"loading":_vm.isLoading,"rules":_vm.rules,"hide-no-data":"","color":_vm.color,"outlined":_vm.outlined,"background-color":"white","hide-details":""},on:{"change":_vm.valueChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }